<template>
    <section class="position-relative">
        <cargando v-if="cargando" />
        <div class="row mx-0 align-items-center">
            <div>
                <i class="icon icon-left f-25 text-muted cr-pointer" @click="$router.back()" />
            </div>
            <div class="col-auto f-500 f-18 text-general px-0">
                Carpeta > {{carpeta.carpeta}}
            </div>
            <div class="btn-general ml-auto f-14 px-3 " @click="crear">
                Agregar Documento
            </div>
        </div>
        <div class="row mx-0 bg-white br-8 px-2 mt-2">
            <div class="col-12 px-0 bg-white br-t-12">
                <tabla-general
                :data="docs"
                class-header="text-general f-14"
                alto="calc(100vh - 182px)"
                :usar-paginacion="false"
                :mostrar-buscador="true"
                >
                    <template slot="adicionales-izquierda">
                        <el-table-column label="Documento" min-width="500" sortable >
                            <template slot-scope="{ row }">
                                <div class="d-middle">
                                    <img v-if="row.extension == 'pdf'" src="/img/icons/pdf.svg" width="40" height="40" class="br-t-12 obj-cover" />
                                    <img v-if="row.extension == 'jpg' || row.extension == 'png' || row.extension == 'jpeg'" src="/img/icons/png.svg" width="40" height="40" class="br-t-12 obj-cover" />
                                    <img v-if="row.extension == 'doc' || row.extension == 'docx'" src="/img/icons/word-doc.svg" width="40" height="40" class="br-t-12 obj-cover" />
                                    <img v-if="row.extension == 'xlsx'" src="/img/icons/excel.svg" width="40" height="40" class="br-t-12 obj-cover" />
                                    <p class="ml-1 ucfirst f-13 cr-pointer text-general" style="line-height: normal;" @click="openFile(row.url)">
                                            {{row.nombre}}
                                    </p>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="Creado por" min-width="200" class="text-general text-right">
                            <template slot-scope="{ row }">
                                {{ row.creador }}
                            </template>
                        </el-table-column>
                        <el-table-column label="Fecha" width="200" class="text-general text-right" sortable>
                            <template slot-scope="{ row }">
                                {{ formatearFecha(row.created_at, "DD/MM/YYYY") }}
                            </template>
                        </el-table-column>
                        <el-table-column label="" width="120" class="text-general text-right">
                            <template slot-scope="{ row }">
                                <div class="btn btn-danger f-12" @click="modalEliminar(row.id)">
                                    Eliminar
                                </div>
                            </template>
                        </el-table-column>
                    </template>
                </tabla-general>
            </div>
        </div>
        <modal ref="modalSubirArchivo" titulo="Subir archivo" no-aceptar :cargado-modal="cargando" adicional="Cargar" @adicional="subirDocumento">
            <p class="mx-0 f-14 px-4 text-general">Por favor seleccione el archivo que desea subir.</p>
            <div class="row mx-0 px-4 my-2">
                <p class="f-14">nombre del documento</p>
                <el-input v-model="form.nombre" size="small"  show-word-limit maxlength="60" />
            </div>
            <div class="row mx-0 align-items-center py-3 px-4">
                <el-upload
                ref="upload"
                action="#"
                :on-change="changeFile"
                :on-remove="removeFile"
                :auto-upload="false"
                :multiple="false"
                :limit="1"
                accept=".pdf, .xlsx, .docx, .jpg, .jpeg, .png"
                >
                    <div class="bg-general2 text-white br-8 px-3 py-1 f-16 cr-pointer shadow">
                        Seleccionar archivo
                    </div>
                </el-upload>
            </div>
            <p class="mx-0 f-14 px-4 text-general">
                Solo se aceptan archivos con extención <br>
                ( .pdf - .xlsx - .docx - .jpg  - .png )</p>
        </modal>
        <modalSiNo
            ref="modalEliminarDocumento"
            titulo="Eliminar Documento"
            mensaje="¿Desea eliminar este documento?"
            icon="close"
            @accion="eliminarDocumento"
            />
    </section>
</template>

<script>
//import {mapGetters} from 'vuex'
import Service from '~/services/biblioteca/biblioteca'
export default {
    components: {
       //modalCrear: () => import('./partials/modalCrearEmpacador')
    },
    data(){
        return {
            cargando: false,
            carpeta: {},
            docs: [],
            buscar: '',
            form: {
                nombre: '',
                file:null
            },
            file: null
        }
    },
    computed:{
        // ...mapGetters({
        //     id_cedis:'cedis/id_cedis',
        // }),
        id_carpeta(){
            return Number(this.$route.params.id_carpeta);
        }
    },
    mounted(){
        this.getDocumentos();
    },
    methods: {
        async getDocumentos(){
            try{
                this.cargando = true;
                const {data} = await Service.getDocumentos(this.id_carpeta)
                this.docs = data.data.docs;
                this.carpeta = data.data.carpeta;
            } catch (e){
                this.error_catch(e)
            } finally{
                this.cargando = false
            }
        },
        async subirDocumento() {
            try{
                if(this.file == null) return
                if (!this.form.nombre) return
                this.cargando = true;
                this.form.file = this.file
                this.form.id_carpeta = this.id_carpeta
                let formData = this.crear_formData(this.form)
                const {data} = await Service.subirDocumento(formData)
                this.notificacion('Mensaje', 'Documento subido correctamente', 'success');
                await this.getDocumentos();
                this.$refs.modalSubirArchivo.toggle();
            } catch (e){
                this.error_catch(e)
            } finally{
                this.cargando = false
            }
        },
        
        crear(){
            this.file = null
            this.form.nombre = ''
            this.$refs.modalSubirArchivo.toggle();
        },
        changeFile(file){
            this.file = file.raw
        },
        removeFile(){
            this.file = null
        },
        openFile(file){
            window.open(file, '_blank')
        },
        modalEliminar(id){
            this.form.id = id;
            this.$refs.modalEliminarDocumento.toggle();
        },
        async eliminarDocumento() {
            try{
                if(!this.form.id) return
                this.cargando = true;
                const {data} = await Service.eliminarDocumento(this.form.id)
                this.notificacion('Mensaje', 'Documento eliminado', 'success');
                this.form.id = null;
                await this.getDocumentos();
                this.$refs.modalEliminarDocumento.toggle();
            } catch (e){
                this.error_catch(e)
            } finally{
                this.cargando = false
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.card-picking{
    width: 162px;
    height: 283px;
    border-radius: 12px;
    background-color: #FFFFFF;
    box-shadow: 1px 2px 8px #6B707414;
}
</style>